import React, {useContext} from 'react';
import ContentLayout from 'src/components/ContentLayout';
import SBPLogo from 'src/components/SBPLogo';
import Text from 'src/components/Text';
import { AuthorizationContext } from 'src/contexts/authorizationContext';
import Form from './Form';
import styles from './styles.module.scss';

const ChangePassword: React.FC = () => {
  const authorizationState = useContext(AuthorizationContext);
  
  return (
    <ContentLayout size="small">
      <SBPLogo className={styles['sbp-logo']} />
      <Text type="h2" className={styles['title']}>Изменение пароля</Text>
      <Text type="p" muted>Создайте новый пароль для входа по номеру {authorizationState?.userId || ''}</Text>
      <Form />
    </ContentLayout>
  );
};

export default ChangePassword;
